import { render, staticRenderFns } from "./AddNewTask.vue?vue&type=template&id=5691a097"
import script from "./AddNewTask.vue?vue&type=script&lang=ts"
export * from "./AddNewTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports